// GAVION call-brief-pipeline: « Envoyer dans le pipeline » (send a lead to the pipeline).
export const sendPipelineEn = {
  button: "Send to pipeline",
  view_deal: "View the deal",
  title: "Send to the pipeline",
  stage: "Stage",
  date: "Date (optional)",
  date_hint: "The demo or meeting date, when one is planned.",
  cancel: "Cancel",
  submit: "Send to the pipeline",
  done: "Lead sent to the pipeline",
  open_deal: "Open the deal",
  errors: {
    invalid_stage: "This stage is not an open pipeline stage.",
    forbidden: "This lead is assigned to another rep.",
    not_found: "Lead not found.",
    do_not_call:
      "This lead is marked « Do not call »: it cannot go to the pipeline.",
    unknown: "The lead could not be sent to the pipeline. Try again.",
  },
};
